import { useState } from "react";

interface UsePaginationParams {
  itemsPerPage?: number;
}

interface UsePaginationReturn {
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}

const usePagination = ({ itemsPerPage = 5 }: UsePaginationParams): UsePaginationReturn => {
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(itemsPerPage);

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
  };
};

export default usePagination;
